// sleep by timeout
function sleep(time) {
    if (!time) {
        return new Promise(resolve => {
            resolve();
        });
    }
    //
    let handler = null;
    let resolveDo = null;
    handler = setTimeout(() => {
        console.log('SLEEP', time, handler);
        if (resolveDo) {
            resolveDo(time);
        }
        clearTimeout(handler);
    }, time);
    //
    return new Promise(resolve => {
        if (handler !== null) {
            resolveDo = resolve;
        } else {
            resolve();
        }
    });
}

//
export { sleep };
